import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { getList } from '@store/dashboards/list/actions';
import { init as initSharedTabs } from '@store/sharedTabs';
import { changeActiveDashboardId } from '@store/common/actions';
import { useContextMenu } from 'react-contexify';
import styles from './index.less';
import ContextMenu, { MENU_ID } from './ContextMenu';
import { tabsListSelector } from './ContextMenu/utils';
import { tid } from '@utils/test';
import EIAITabs from './EIAITabs';
import AppTabs from './AppTabs';
import Eco2Tabs from './Eco2Tabs';
import RenderFor from '@components/platform/RenderFor';

const DashboardTabs = ({ className, id, currentShareId, hidden = false }) => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    dispatch(initSharedTabs());
    dispatch(getList());
  }, []);

  // set the active dashboard id in store
  React.useEffect(() => {
    dispatch(changeActiveDashboardId(id));
  }, [dispatch, id]);

  // right click context menu
  const { show } = useContextMenu({ id: MENU_ID });
  const hasTempTabs = useSelector(tabsListSelector);
  const displayMenu = (e) => {
    if (hasTempTabs) {
      show(e);
    }
  };

  const shareId = currentShareId || id;
  const isPresetPage = window.location.pathname.includes('preset');

  const shouldHideTabs = hidden || isPresetPage;

  return (
    <div
      className={classnames(className, styles.dashboardTabsWrapper, {
        [styles.hideTabs]: shouldHideTabs,
      })}
      {...tid('dashboard-tabs')}
    >
      <div className={styles.closeTabsContextWrapper} onContextMenu={displayMenu}>
        <RenderFor.App>
          <AppTabs shareId={shareId} />
        </RenderFor.App>
        <RenderFor.EIandAI>
          <EIAITabs shareId={shareId} />
        </RenderFor.EIandAI>
        <RenderFor.Odp>
          <></>
        </RenderFor.Odp>
        <RenderFor.EcoServer>
          <Eco2Tabs activeId={id} />
        </RenderFor.EcoServer>
        <ContextMenu />
      </div>
    </div>
  );
};

DashboardTabs.defaultProps = {
  className: '',
  id: -1,
  currentShareId: '',
  hidden: false,
};

export default DashboardTabs;
